import i18n from "@/lib/i18n";
import React from "react";
import { ProductSelectionModal } from "@/components/quotes/ProductSelectionModal";
import { ProductSelection } from "@/types/product";

interface ProductSelectionButtonProps {
  selectedProducts: ProductSelection[];
  onProductsChange: (products: ProductSelection[]) => void;
  showPricing?: boolean;
  disabled?: boolean;
  triggerText?: string;
  modalTitle?: string;
  modalSize?: "sm" | "default" | "lg";
}

/**
 * Standalone product selection button component.
 * Opens a modal to select products from the catalog.
 * Completely decoupled from the selected products display.
 */
export const ProductSelectionButton: React.FC<ProductSelectionButtonProps> = ({
  selectedProducts,
  onProductsChange,
  showPricing = false,
  disabled = false,
  triggerText = i18n.t("components.products.productSelectionButton.selectProducts"),
  modalTitle = i18n.t("components.products.productSelectionButton.productCatalog"),
  modalSize = "sm",
}) => {
  return (
    <ProductSelectionModal
      selectedProducts={selectedProducts}
      onProductsChange={onProductsChange}
      showPricing={showPricing}
      disabled={disabled}
      triggerText={triggerText}
      title={modalTitle}
      size={modalSize}
    />
  );
};
